import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Trash2 } from "lucide-react";
import { api, errMsg, fmtDate } from "@/lib/api";

export const Festivos = () => {
  const [list, setList] = useState([]);
  const [fecha, setFecha] = useState("");
  const [nombre, setNombre] = useState("");
  useEffect(() => {
    api.get("/festivos").then((r) => setList(r.data));
  }, []);
  const add = async () => {
    if (!fecha) return toast.error("Elige la fecha");
    try {
      const { data } = await api.post("/festivos", { fecha, nombre });
      setList(data);
      setFecha("");
      setNombre("");
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  const del = async (f) => setList((await api.delete(`/festivos/${f}`)).data);
  return (
    <div className="space-y-3 text-sm" data-testid="festivos">
      <p className="text-slate-600">En las mensualidades, el primer festivo del mes que caiga en el día de sesión no se recupera; si hay un segundo festivo ese mes, ese sí. Los meses con 5 semanas se cobran igual.</p>
      <div className="flex flex-wrap gap-2">
        <input type="date" value={fecha} onChange={(e) => setFecha(e.target.value)} data-testid="festivo-fecha" className="h-9 rounded border border-slate-200 px-2" />
        <input value={nombre} onChange={(e) => setNombre(e.target.value)} placeholder="Nombre (opcional)" data-testid="festivo-nombre" className="h-9 flex-1 min-w-[160px] rounded border border-slate-200 px-2" />
        <button onClick={add} data-testid="festivo-add-btn" className="h-9 rounded-md bg-[#1E3A8A] px-4 text-white">Añadir festivo</button>
      </div>
      <div className="divide-y divide-slate-100">
        {list.map((f) => (
          <div key={f.fecha} className="flex items-center gap-3 py-1.5" data-testid={`festivo-${f.fecha}`}>
            <span className="w-28 font-[JetBrains_Mono] text-xs">{fmtDate(f.fecha)}</span>
            <span className="flex-1 text-slate-700">{f.nombre}</span>
            <button onClick={() => del(f.fecha)} data-testid={`festivo-del-${f.fecha}`} className="text-slate-400 hover:text-rose-600"><Trash2 className="h-4 w-4" /></button>
          </div>
        ))}
        {!list.length && <div className="py-2 text-slate-400">Aún no hay festivos apuntados.</div>}
      </div>
    </div>
  );
};
